// SY12 콤보 조회 — 2.0 GET /api/v1/system/combos (LOGISPRD-17281, MOMS_COMBO_INFO). 페이지네이션 없음, 정렬은 BE(COMBO_CD → id).
import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import request from '@/utils/request'
import { formatDateTime14 } from '@/utils/format/legacyDate'
import { MENU_CODE } from '../consts'

/** 표 행 — 키는 1.0 COLUMN_CD(화면관리 SY12_HEAD 컬럼 코드와 같아야 설정이 붙는다, docs/conventions/grid-code.md) */
export interface ComboRow {
  /** 수정·삭제(/{id}) 대상 식별자 — 2.0 응답 id. 화면 표시엔 미사용 */
  _id: number
  COMBO_CD: string
  COMBO_NM: string
  COMBO_OPT_CD: string
  COMBO_OPT_NM: string
  INS_DATE: string
  INS_BY: string
  UPD_DATE: string
  UPD_BY: string
}

export interface ComboParams {
  comboCode?: string
  comboName?: string
}

interface ComboItem {
  id: number
  comboCode: string
  comboName?: string | null
  optionCode: string
  optionName?: string | null
  insertedAt?: string | null
  insertedBy?: string | null
  updatedAt?: string | null
  updatedBy?: string | null
}

/** 일시는 DB 문자열 그대로 온다 — 새 값 14자(yyyyMMddHHmmss), 옛 1.0 값 18자(뒤 4자리는 초 아래 자리). 둘 다 앞 14자로 표기한다. */
const fmtDate = (v?: string | null) => (v ? formatDateTime14(/^\d{18}$/.test(v) ? v.slice(0, 14) : v) : '')

const toRow = (i: ComboItem): ComboRow => ({
  _id: i.id,
  COMBO_CD: i.comboCode,
  COMBO_NM: i.comboName ?? '',
  COMBO_OPT_CD: i.optionCode,
  COMBO_OPT_NM: i.optionName ?? '',
  INS_DATE: fmtDate(i.insertedAt),
  INS_BY: i.insertedBy ?? '',
  UPD_DATE: fmtDate(i.updatedAt),
  UPD_BY: i.updatedBy ?? '',
})

export const COMBOS_PATH = '/api/v1/system/combos'

/** Query key — 맨 앞은 메뉴코드(탭 닫기 캐시 삭제). 무효화는 all, 조회는 list(params). */
export const comboQueryKeys = {
  all: [MENU_CODE, 'getComboList'] as const,
  list: (params: ComboParams) => [...comboQueryKeys.all, params] as const,
}

export const useGetComboList = (params: ComboParams): UseQueryResult<ComboRow[], Error> =>
  useQuery({
    queryKey: comboQueryKeys.list(params),
    queryFn: async () => {
      const res = await request.get<ApiResponseV2<{ items: ComboItem[] }>, ComboParams>(COMBOS_PATH, params)
      return (res.data?.items ?? []).map(toRow)
    },
  })
